<template>
	<div v-html="formatDate()"></div>
</template>

<script>
	export default {
		name: "DateFormatter",
		props: {
			date: {
				required: true,
				type: String,
			},
			format: {
				required: false,
				type: String,
				default: "ddd DD/MM/YY LT",
			},
			timezone: {
				required: false,
				type: String,
			},
			useBrowserTimezone: {
				required: false,
				type: Boolean,
				default: false,
			},
		},
		methods: {
			formatDate(date) {
				let browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
				// is the browser timezone if we can get it
				if (this.useBrowserTimezone && browserTimezone) {
					return this.$moment.utc(this.date).tz(browserTimezone).format(this.format)
				} else if (this.timezone) {
					// use the timezone passed through
					return this.$moment.utc(this.date).tz(this.timezone).format(this.format)
				} else {
					// return UTC
					return this.$moment.utc(this.date).format(this.format) + " (UTC)"
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
